/* ══════════════════════════════════════
   SOAR Article Main
   - Copy link button
   - Reading progress bar
══════════════════════════════════════ */

(function () {
  if (customElements.get('soar-article-main')) return;

  class SoarArticleMain extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onCopyClick = this._onCopyClick.bind(this);
      this._copyResetTimer = null;
    }

    connectedCallback() {
      this._initCopyLink();
      this._initProgressBar();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      if (this._copyResetTimer) clearTimeout(this._copyResetTimer);
    }

    /* ── Copy link ── */
    _initCopyLink() {
      this._copyBtn = this.querySelector('[data-copy-link]');
      if (!this._copyBtn) return;
      this._copyBtn.addEventListener('click', this._onCopyClick);
    }

    async _onCopyClick() {
      const url = window.location.href;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          // Fallback for non-secure contexts
          const tmp = document.createElement('textarea');
          tmp.value = url;
          tmp.style.position = 'fixed';
          tmp.style.opacity = '0';
          document.body.appendChild(tmp);
          tmp.focus();
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
        }
      } catch (err) {
        console.warn('SOAR Article: copy failed', err);
        return;
      }

      this._copyBtn.classList.add('is-copied');
      this._copyBtn.setAttribute('aria-label', 'Link copied to clipboard');
      if (this._copyResetTimer) clearTimeout(this._copyResetTimer);
      this._copyResetTimer = setTimeout(() => {
        this._copyBtn.classList.remove('is-copied');
        this._copyBtn.setAttribute('aria-label', 'Copy link to article');
      }, 2000);
    }

    /* ── Reading progress bar ── */
    _initProgressBar() {
      if (this.dataset.progressBar !== 'true') return;
      this._fill = this.querySelector('[data-progress-fill]');
      this._article = this.querySelector('.soar-article-main__body');
      if (!this._fill || !this._article) return;

      this._onScroll();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
    }

    _onScroll() {
      if (!this._fill || !this._article) return;

      const rect = this._article.getBoundingClientRect();
      const winH = window.innerHeight || document.documentElement.clientHeight;
      const total = rect.height - winH;
      if (total <= 0) {
        this._fill.style.width = '100%';
        return;
      }

      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      const pct = (scrolled / total) * 100;
      this._fill.style.width = pct + '%';
    }
  }

  customElements.define('soar-article-main', SoarArticleMain);
})();
